// buildPayload.js

export const buildPayload = ({
  source,
  target,
  sourceApiKey,
  sourceCollection,
  sourceDbName,
  sourceUrl,
  targetApiKey,
  targetCollection,
  targetDbName,
  targetUrl,
  namespace,
  batchSize,
  sourceEmbeddingField,
  targetEmbeddingField,
}) => {
  const key = `${source}_${target}`;
  const batch = batchSize ? Number(batchSize) : undefined;

  switch (key) {
    /* ---------- PINECONE TO X ---------- */
    case "pinecone_milvus":
      return {
        pinecone_api_key: sourceApiKey,
        pinecone_index_name: sourceCollection,
        pinecone_namespace: namespace || null,
        milvus_uri: targetUrl,
        milvus_token: targetApiKey,
        milvus_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pinecone_qdrant":
      return {
        pinecone_api_key: sourceApiKey,
        pinecone_index_name: sourceCollection,
        pinecone_namespace: namespace || null,
        qdrant_url: targetUrl,
        qdrant_api_key: targetApiKey,
        qdrant_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pinecone_chroma":
      return {
        pinecone_api_key: sourceApiKey,
        pinecone_index_name: sourceCollection,
        pinecone_namespace: namespace || null,
        chroma_api_key: targetApiKey,
        chroma_tenant: targetUrl,
        chroma_database: targetDbName || null,
        chroma_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pinecone_weaviate":
      return {
        pinecone_api_key: sourceApiKey,
        pinecone_index_name: sourceCollection,
        pinecone_namespace: namespace || null,
        weaviate_url: targetUrl,
        weaviate_api_key: targetApiKey,
        weaviate_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pinecone_mongo":
      return {
        pinecone_api_key: sourceApiKey,
        pinecone_index_name: sourceCollection,
        pinecone_namespace: namespace || null,
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "pinecone_pgvector":
      return {
        pinecone_api_key: sourceApiKey,
        pinecone_index_name: sourceCollection,
        pinecone_namespace: namespace || null,
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    /* ---------- MILVUS TO X ---------- */
    case "milvus_milvus":
      return {
        source_milvus_uri: sourceUrl,
        source_milvus_token: sourceApiKey,
        source_collection_name: sourceCollection,
        target_milvus_uri: targetUrl,
        target_milvus_token: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "milvus_qdrant":
      return {
        source_milvus_uri: sourceUrl,
        source_milvus_token: sourceApiKey,
        source_collection_name: sourceCollection,
        target_qdrant_url: targetUrl,
        target_qdrant_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "milvus_chroma":
      return {
        source_milvus_uri: sourceUrl,
        source_milvus_token: sourceApiKey,
        source_collection_name: sourceCollection,
        target_chroma_api_key: targetApiKey,
        target_chroma_tenant: targetUrl,
        target_chroma_database: targetDbName,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "milvus_weaviate":
      return {
        source_milvus_uri: sourceUrl,
        source_milvus_token: sourceApiKey,
        source_collection_name: sourceCollection,
        target_weaviate_url: targetUrl,
        target_weaviate_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "milvus_mongo":
      return {
        source_milvus_uri: sourceUrl,
        source_milvus_token: sourceApiKey,
        source_collection_name: sourceCollection,
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "milvus_pgvector":
      return {
        source_milvus_uri: sourceUrl,
        source_milvus_token: sourceApiKey,
        source_collection_name: sourceCollection,
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    /* ---------- QDRANT TO X ---------- */
    case "qdrant_milvus":
      return {
        source_qdrant_url: sourceUrl,
        source_qdrant_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_milvus_uri: targetUrl,
        target_milvus_token: targetApiKey,
        target_milvus_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "qdrant_chroma":
      return {
        qdrant_url: sourceUrl,
        qdrant_api_key: sourceApiKey,
        qdrant_collection_name: sourceCollection,
        chroma_api_key: targetApiKey,
        chroma_tenant: targetUrl,
        chroma_database: targetDbName,
        chroma_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "qdrant_qdrant":
      return {
        source_qdrant_url: sourceUrl,
        source_qdrant_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_qdrant_url: targetUrl,
        target_qdrant_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "qdrant_weaviate":
      return {
        source_qdrant_url: sourceUrl,
        source_qdrant_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_weaviate_url: targetUrl,
        target_weaviate_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "qdrant_mongo":
      return {
        source_qdrant_url: sourceUrl,
        source_qdrant_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "qdrant_pgvector":
      return {
        source_qdrant_url: sourceUrl,
        source_qdrant_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    /* ---------- CHROMA TO X ---------- */
    case "chroma_milvus":
      return {
        source_chroma_api_key: sourceApiKey,
        source_chroma_tenant: sourceUrl,
        source_chroma_database: sourceDbName,
        source_collection_name: sourceCollection,
        target_milvus_uri: targetUrl,
        target_milvus_token: targetApiKey,
        target_milvus_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "chroma_qdrant":
      return {
        chroma_api_key: sourceApiKey,
        chroma_tenant: sourceUrl,
        chroma_database: sourceDbName,
        chroma_collection_name: sourceCollection,
        qdrant_url: targetUrl,
        qdrant_api_key: targetApiKey,
        qdrant_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "chroma_chroma":
      return {
        source_chroma_api_key: sourceApiKey,
        source_chroma_tenant: sourceUrl,
        source_chroma_database: sourceDbName,
        source_collection_name: sourceCollection,
        target_chroma_api_key: targetApiKey,
        target_chroma_tenant: targetUrl,
        target_chroma_database: targetDbName,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "chroma_weaviate":
      return {
        chroma_api_key: sourceApiKey,
        chroma_tenant: sourceUrl,
        chroma_database: sourceDbName,
        chroma_collection_name: sourceCollection,
        weaviate_url: targetUrl,
        weaviate_api_key: targetApiKey,
        weaviate_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "chroma_mongo":
      return {
        source_chroma_api_key: sourceApiKey,
        source_chroma_tenant: sourceUrl,
        source_chroma_database: sourceDbName,
        source_collection_name: sourceCollection,
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "chroma_pgvector":
      return {
        source_chroma_api_key: sourceApiKey,
        source_chroma_tenant: sourceUrl,
        source_chroma_database: sourceDbName,
        source_collection_name: sourceCollection,
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    /* ---------- WEAVIATE TO X ---------- */
    case "weaviate_milvus":
      return {
        source_weaviate_url: sourceUrl,
        source_weaviate_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_milvus_uri: targetUrl,
        target_milvus_token: targetApiKey,
        target_milvus_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "weaviate_qdrant":
      return {
        source_weaviate_url: sourceUrl,
        source_weaviate_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_qdrant_url: targetUrl,
        target_qdrant_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "weaviate_chroma":
      return {
        source_weaviate_url: sourceUrl,
        source_weaviate_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_chroma_api_key: targetApiKey,
        target_chroma_tenant: targetUrl,
        target_chroma_database: targetDbName,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "weaviate_weaviate":
      return {
        source_weaviate_url: sourceUrl,
        source_weaviate_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_weaviate_url: targetUrl,
        target_weaviate_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "weaviate_mongo":
      return {
        source_weaviate_url: sourceUrl,
        source_weaviate_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "weaviate_pgvector":
      return {
        source_weaviate_url: sourceUrl,
        source_weaviate_api_key: sourceApiKey,
        source_collection_name: sourceCollection,
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    /* ---------- MONGO TO X ---------- */
    case "mongo_pinecone":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        pinecone_api_key: targetApiKey,
        pinecone_index_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "mongo_milvus":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        target_milvus_uri: targetUrl,
        target_milvus_token: targetApiKey,
        target_milvus_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "mongo_qdrant":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        target_qdrant_url: targetUrl,
        target_qdrant_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "mongo_chroma":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        target_chroma_api_key: targetApiKey,
        target_chroma_tenant: targetUrl,
        target_chroma_database: targetDbName,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "mongo_weaviate":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        target_weaviate_url: targetUrl,
        target_weaviate_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "mongo_mongo":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "mongo_pgvector":
      return {
        source_mongo_uri: sourceUrl,
        source_mongo_database: sourceDbName,
        source_collection_name: sourceCollection,
        source_embedding_field: sourceEmbeddingField || "embeddings",
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    /* ---------- PGVECTOR TO X ---------- */
    case "pgvector_milvus":
      return {
        source_pg_connection_string: sourceUrl,
        source_table_name: sourceCollection,
        source_vector_column: sourceEmbeddingField || "embedding",
        source_id_column: "id",
        target_milvus_uri: targetUrl,
        target_milvus_token: targetApiKey,
        target_milvus_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pgvector_qdrant":
      return {
        source_pg_connection_string: sourceUrl,
        source_table_name: sourceCollection,
        source_vector_column: sourceEmbeddingField || "embedding",
        source_id_column: "id",
        target_qdrant_url: targetUrl,
        target_qdrant_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pgvector_chroma":
      return {
        source_pg_connection_string: sourceUrl,
        source_table_name: sourceCollection,
        source_vector_column: sourceEmbeddingField || "embedding",
        source_id_column: "id",
        target_chroma_api_key: targetApiKey,
        target_chroma_tenant: targetUrl,
        target_chroma_database: targetDbName,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pgvector_weaviate":
      return {
        source_pg_connection_string: sourceUrl,
        source_table_name: sourceCollection,
        source_vector_column: sourceEmbeddingField || "embedding",
        source_id_column: "id",
        target_weaviate_url: targetUrl,
        target_weaviate_api_key: targetApiKey,
        target_collection_name: targetCollection,
        ...(batch && { batch_size: batch }),
      };

    case "pgvector_mongo":
      return {
        source_pg_connection_string: sourceUrl,
        source_table_name: sourceCollection,
        source_vector_column: sourceEmbeddingField || "embedding",
        source_id_column: "id",
        target_mongo_uri: targetUrl,
        target_mongo_database: targetDbName,
        target_collection_name: targetCollection,
        target_embedding_field: targetEmbeddingField || "embeddings",
        ...(batch && { batch_size: batch }),
      };

    case "pgvector_pgvector":
      return {
        source_pg_connection_string: sourceUrl,
        source_table_name: sourceCollection,
        source_vector_column: sourceEmbeddingField || "embedding",
        source_id_column: "id",
        target_pg_connection_string: targetUrl,
        target_table_name: targetCollection,
        target_vector_column: targetEmbeddingField || "embedding",
        target_id_column: "id",
        ...(batch && { batch_size: batch }),
      };

    default:
      return null;
  }
};